import { get } from "lodash";
import React from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { useFormState } from "react-final-form";
import { bookmakersConfig } from "../../bookmakers";

const BookmakersInput = (props) => {
	const form = useFormState();
	const filter = {
		bookmaker_type_id: get(form, "values.bookmaker_type_id"),
	};
	return (
		<ReferenceInput
			source="bookmaker_id"
			reference="bookmakers"
			alwaysOn
			fullWidth
			allowEmpty
			emptyText="ra.action.all"
			filter={filter}
			{...bookmakersConfig.reference}
			{...props}
		>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
	);
};

export default BookmakersInput;
